import React, { useState, useEffect, useMemo } from "react";
import DataTable from "../components/DataTable.js";
import {
  fetchDataFromAPI,
  saveData,
  deleteData,
  fetchAllPagesData,
} from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};
const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState(""); // Track the current sorted field
  const [sortOrder, setSortOrder] = useState("desc"); // Track the current sort order
  const [ordersOptions, setOrdersOptions] = useState([]);
  const [error, setError] = useState(null);
  const [AllCustomers, setAllCustomers] = useState("");

  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const isSubscribed = subscriptionStatus();
  useEffect(() => {
    fetchData();
    console.log("referching data", currentPage, filters, sortField, sortOrder);
  }, [filters, sortField, sortOrder]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters) => {
    try {
      console.log("fetchData", filters, sortField, sortOrder);
      const token = localStorage.getItem("token");
      console.log("filters", filters);

      // Prepare query parameters

      // Dynamically construct query parameters, excluding empty sortField and sortOrder
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters,
        includeDeleted: "false",
      };

      // Add sortField and sortOrder only if they are not empty
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      console.log("Filter Params:", new URLSearchParams(filterParamsObj));

      // Create the query string
      const filterParams = new URLSearchParams(filterParamsObj).toString();

      // Fetch suppliers and materials concurrently
      const { data: customers, pagination } = await fetchDataFromAPI(
        `/api/customers`,
        filterParams,
        token
      );

      const { data: orders } = await fetchDataFromAPI(`/api/orders`, {}, token);
      const AllCustomers = await fetchAllPagesData("/api/customers", {
        filters: { country: "Egypt" },
        sortField: "created_at",
        sortOrder: "desc",
        limit: 200,
      });

      console.log("Exporting", customers.length, "customers...");
      // Update state
      setCustomers(customers || []);
      setOrdersOptions(orders);
      setTotalPages(pagination?.totalPages || 1);
      setAllCustomers(AllCustomers);
      console.log("Orders:", orders);
      console.log("Customers:", customers);
      console.log("AllCustomers", AllCustomers);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError(err.message);
    }
  };
  useEffect(() => {
    // Log orders every time ordersOptions is updated
    console.log("Orders Options updated:", ordersOptions);
  }, [ordersOptions]);

  const handleAddRow = async () => {
    try {
      const newRow = {
        name: "New customer",
      };

      if (isOffline) {
        storeOfflineData([newRow], "customers", "add"); // Store the new customer offline
      } else {
        await saveData("/api/customers", newRow, "POST");
      }
      fetchData();
    } catch (err) {
      console.error("Error adding row:", err);
    }
  };

  const handleEdit = async (id, updatedData) => {
    try {
      if (isOffline) {
        storeOfflineData([updatedData], "customers", "update"); // Store the updated data offline
      } else {
        await saveData(`/api/customers/${id}`, updatedData);
      }
      fetchData();
    } catch (err) {
      console.error("Error editing order:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      if (isOffline) {
        storeOfflineData([{ id }], "customers", "delete"); // Store the deletion offline
      } else {
        await deleteData(`/api/customers/${id}`);
      }
      fetchData();
    } catch (err) {
      console.error("Error deleting order:", err);
    }
  };
  const handlePageChange = (newPage) => {
    console.log("Parent - Page changed to:", newPage); // Log in parent
    setCurrentPage(newPage); // Update the current page
    fetchData(newPage, 10); // Fetch new data
  };
  const handleSort = (field, order) => {
    console.log("handleSort,field,order", field, order);
    setSortField(field); // Update the sorted field
    setSortOrder(order); // Update the sort order (asc/desc)
  };
  const handleFilterChange = (newFilters) => {
    console.log("handleFilterChange", newFilters);
    setFilters(newFilters); // Update filters in the parent state
    fetchData(currentPage, newFilters); // Refetch data with new filters
  };
  const columns = [
    { header: "Customer ", accessor: "name" },
    { header: "Age ", accessor: "age", type: "range" },
    { header: "Gender ", accessor: "gender" },

    { header: "Type ", accessor: "type" },
    { header: "Location ", accessor: "location" },
    { header: "Address ", accessor: "billing_address" },
    { header: "Date of birth ", accessor: "date_of_birth", type: "Date" },
    { header: "orders number ", accessor: "number_of_orders" },
    {
      header: "Orders",
      accessor: "orders",
      type: "TextDetails",
      //   options: ordersOptions,
    },
    { header: "Phone ", accessor: "phone_number" },
    { header: "contact method", accessor: "preferred_contact_method" },
    {
      header: "status ",
      accessor: "status",
      type: "dropdown",
      options: [
        { value: "active", label: "active" },

        { value: "inactive", label: "inactive" },
      ],
    },

    { header: "Loyalty points ", accessor: "loyalty_points", type: "range" },

    { header: "Amount paid ", accessor: "amount_paid", type: "range" },
  ];

  console.log("columns", columns);
  return (
    <DataTable
      title="Customers"
      columns={columns}
      data={customers}
      currentPage={currentPage}
      setData={setCustomers}
      totalPages={totalPages}
      onSort={handleSort}
      sortOrder={sortOrder}
      sortField={sortField}
      onPageChange={handlePageChange}
      filters={filters}
      onFilterChange={handleFilterChange}
      onAddRow={handleAddRow}
      actions={[
        {
          label: "Edit",
          onClick: (row) => {
            const updatedData = { ...row, name: "Updated Name" };
            handleEdit(row.id, updatedData);
          },
        },
        {
          label: "Delete",
          onClick: (row) => handleDelete(row.id),
        },
      ]}
      apiEndpoint="/api/customers"
      itemsPerPage={10}
      fetchData={fetchData}
      getRangeInputProps={getRangeInputProps}
      selectedItems={customers.orders}
      allData={AllCustomers}
    />
  );
};

export default Customers;
